module.exports = __webpack_public_path__ + "wat.jpg?fb711765047a3c9cfafc12f95c666141";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/trusted/wat.jpg
// module id = 148
// module chunks = 0